import axios from "axios";
import { baseURL } from "../../utils/URL";

const onGetAllmoduules = async ( config: any) => {
    try {
      const response = await axios.get(`${baseURL}/module`, config);
      return response.data;
    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };


  
  const onGetOrgModules = async (id:any, config: any) => {
    try {
      const response = await axios.get(`${baseURL}/module/organization/${id}`, config);
      return response.data;
    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };

  
const onAddOrgModule = async ( postData:any ,config: any) => {
    try {
      const response = await axios.post(`${baseURL}/module/organization`, postData,config);
      return response.data;
    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };

  

  

  export{onGetAllmoduules, onGetOrgModules,onAddOrgModule}